<template>
    <i class="fas" :class="[icon]"/>
</template>

<script>
export default {
    props: {
        type: String,
    },

    computed: {
        icon() {
            switch (this.type) {
                case 'delivery':
                    return 'fa-truck'

                case 'pickup':
                    return 'fa-people-carry'

                case 'reservation':
                    return 'fa-map-marker-alt'

                default:
                    return 'fa-question'
            }
        },
    },
}
</script>
